var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { STACK_ALIGN, STACK_DIRECTION, StackView } from "../../StackView";
import { SPACE_FILL } from "../../View";
import { createUIElement } from "../../helpers";
var Root = styled(StackView)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    overflow: hidden;\n    flex: 1;\n"], ["\n    position: relative;\n    overflow: hidden;\n    flex: 1;\n"])));
var Menu = styled(StackView)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    overflow: hidden;\n    flex-shrink: 0;\n    ", "\n"], ["\n    position: relative;\n    overflow: hidden;\n    flex-shrink: 0;\n    ",
    "\n"])), function (_a) {
    var hasSeparator = _a.hasSeparator, theme = _a.theme;
    return hasSeparator && "border-right: 1px solid " + (theme === null || theme === void 0 ? void 0 : theme.colorBorderMain) + ";";
});
var HeaderSection = styled(StackView)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", ";\n"], ["\n    padding: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return "0 " + (theme === null || theme === void 0 ? void 0 : theme.spacing.m);
});
export var SideMenuLayout = createUIElement('SideMenuLayout', function (_a, ref) {
    var className = _a.className, header = _a.header, hasSeparator = _a.hasSeparator, menu = _a.menu, body = _a.body, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "header", "hasSeparator", "menu", "body", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var sideMenuLayout = (React.createElement(Root, __assign({}, rest, { testId: rest['data-selector-id'], className: "vm-SideMenuLayout " + className, direction: STACK_DIRECTION.row, align: STACK_ALIGN.fill, spaceFill: SPACE_FILL.all, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        !!menu && (React.createElement(Menu, { testId: 'page-layout-menu', direction: STACK_DIRECTION.column, hasSeparator: hasSeparator }, menu)),
        !!body && body));
    return header ? (React.createElement(StackView, { direction: STACK_DIRECTION.column, align: STACK_ALIGN.fill, spaceFill: SPACE_FILL.all },
        React.createElement(HeaderSection, null, header),
        sideMenuLayout)) : (sideMenuLayout);
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=SideMenuLayout.js.map